<div class="carousel-mini-card" *ngIf="data?.length > 0">
  <div class="carousel-mini-card__title">Other Featured Posted</div>
  <app-my-carousel-swiper class="my-carousel-width-auto" [config]="options" [navigation]="false">
    <ng-container *ngFor="let i of data">
      <div class="swiper-slide" *ngIf="i.title">
        <div class="my-mini-card-news">
          <img loading="lazy" [routerLink]="'/news/' + (i.slug ?? i.id)" src="{{ imgUrl + i.image }}"
            (error)="commonService.handleError($event)" alt="..." />
          <div class="body">
            <a class="my-mini-card-news__title" [routerLink]="'/news/' + i.slug">
              {{ i.title }}
            </a>
            <!-- <div class="my-mini-card-news__details">
              <div class="item">
                <i class="fa fa-clock"></i>
                <span>{{ convertDate(i.created) }}</span>
              </div>
              <div class="item">
                <i class="fa fa-heart"></i>
                <span>{{ i.bottomBannerLikes?.length }}</span>
              </div>
            </div> -->
          </div>
        </div>
      </div>
    </ng-container>
  </app-my-carousel-swiper>
</div>